import React, { useState } from "react";
import {
  Checkbox,
  TextField,
  Button,
  FormControlLabel,
  Grid,
  Typography,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import theme from "../theme";
import useButtonStyles from "../styles/useButtonStyles";
import { APIConstants } from "../constants/ApiConstants";
import axios from "axios";
import BasicModal from "../components/ui/BasicModal";

interface RedeemProps {
  EVoucher: {
    id: string;
    name: string;
    totalQuantities: number;
    availableQuantities: number;
  }[];
  id: string[];
}

const RedeemCheckBox: React.FC<RedeemProps> = (props) => {
  const { EVoucher, id } = props;

  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(
    "Something went wrong!"
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [checkboxChecked, setCheckboxChecked] = useState<{
    [key: string]: boolean;
  }>({});
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const handleCloseModal = () => {
    setShowModal(false);
    setErrorFlag(false);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    offerId: string
  ) => {
    setCheckboxChecked((prev) => ({
      ...prev,
      [offerId]: event.target.checked,
    }));
  };

  const uploadData = async (
    selectedIds: string[],
    EVoucher: {
      id: string;
      name: string;
      totalQuantities: number;
      availableQuantities: number;
    }[]
  ) => {
    setLoading(true);
    try {
      const payload = {
        // orderIds: EVoucher.map((offer) => offer.id),
        orderIds: selectedIds,
        receipts: id,
      };
      const axiosResponse = await axios.get(
        process.env.REACT_APP_API_URL +
          APIConstants.memberRedemption2 +
          `${payload.receipts}&offerIds=${payload.orderIds}`
      );
      setShowModal(true);
    } catch (error: any) {
      // if (error?.response?.data?.error.length > 0) {
      //   setErrorMessage(error?.response?.data?.error);
      // } else {
      //   setErrorMessage("Redemption failed, Please try again");
      // }
      setErrorFlag(true);
      setErrorMessage(error?.response?.data?.error);
      setShowModal(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const submitHandler = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    const selectedOfferIds = Object.keys(checkboxChecked).filter(
      (offerId) => checkboxChecked[offerId]
    );

    setLoading(true);
    await uploadData(selectedOfferIds, EVoucher);
    setLoading(false);
  };

  return (
    <Grid
      width={"100%"}
      style={{
        display: "flex",
        backgroundColor: theme.color?.background,
        padding: "2rem",
        borderRadius: "1rem",
        justifyContent: "space-around",
      }}
    >
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
          minWidth: "60%",
          borderRight: theme.border?.smallGrey,
        }}
        gap={"0.5rem"}
      >
        <Typography
          style={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.medium,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Eligible Offers
        </Typography>
        <Grid sx={{ marginRight: "20px" }}>
          <TableContainer
            component={Paper}
            style={{
              maxHeight: "300px",
              borderRadius: "8px",
            }}
          >
            <Table stickyHeader>
              <TableHead
                style={{
                  background: theme.color?.tableHeader,
                }}
              >
                <TableRow>
                  <TableCell
                    style={{
                      width: "10%",
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                      background: theme.color?.tableHeader,
                    }}
                  >
                    Offers
                  </TableCell>
                  <TableCell
                    style={{
                      background: theme.color?.tableHeader,
                    }}
                  ></TableCell>
                  <TableCell
                    style={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                      background: theme.color?.tableHeader,
                    }}
                  >
                    Available Quantity
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {EVoucher &&
                  EVoucher.length > 0 &&
                  EVoucher?.map((offer, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkboxChecked[offer.id] || false}
                              onChange={(event) =>
                                handleCheckboxChange(event, offer.id)
                              }
                              disabled={
                                offer.availableQuantities === 0 ||
                                offer.totalQuantities === 0
                              }
                              sx={{
                                "&.Mui-checked": {
                                  color: theme.color?.secondary,
                                },
                              }}
                            />
                          }
                          label={""}
                        />
                      </TableCell>
                      <TableCell
                        style={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        {offer.name}
                        <br></br>
                        <Grid>
                          {offer.availableQuantities === 0 && (
                            <Typography
                              sx={{
                                color: theme.palette.error.main,
                                fontSize: theme.font?.fontSize.tableBody,
                              }}
                            >
                              * User limit exhausted
                            </Typography>
                          )}
                        </Grid>
                      </TableCell>
                      <TableCell
                        style={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        {offer.totalQuantities}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Grid display={"flex"} width={"100%"} flexDirection={"column"}>
        <Grid
          px={4}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            width: "100%",
          }}
        >
          <Typography
            style={{
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: theme.font?.fontSize.medium,
              fontWeight: theme.font?.fontWeight.thick,
            }}
          >
            Remarks
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            style={{ borderRadius: "8px" }}
            multiline
            rows={2}
          />
        </Grid>
        <Grid
          style={{
            display: "flex",
            justifyContent: "right",
            alignItems: "start",
            padding: "2rem",
          }}
        >
          <Button
            variant="contained"
            onClick={submitHandler}
            disabled={!checkboxChecked}
            sx={{
              ...buttonStyles.containedSecondary,
              minHeight: "2.7rem",
              boxShadow: "none",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            {loading ? (
              <CircularProgress size={15} color="inherit" />
            ) : (
              "Redeem"
            )}
          </Button>
        </Grid>
      </Grid>

      {showModal && (
        <BasicModal
          // title={
          //   errorMessage === "Redemption failed, Please try again"
          //     ? "Redemption Failed, Please try again"
          //     : "Redemption Successful"
          // }
          title={errorFlag ? errorMessage : "Redemption Successful"}
          // success={errorMessage !== "Redemption failed, Please try again"}
          success={!errorFlag}
          setState={handleCloseModal}
        />
      )}
    </Grid>
  );
};

export default RedeemCheckBox;
